export function formatErrorName(name) {
    if (name.indexOf('Error') === -1) {
        return name + 'Error';
    }
    return name;
}
